import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { setSessionItem, getSessionItem } from '../shared/utils';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  constructor(private router: Router, private msalService: MsalService) { }

  ngOnInit() {

    // check if user is logged in and redirect
    const user = getSessionItem('accessToken');
    if (user) {
      this.router.navigate(['/cims']);
    }

    // Initialise the msl
    this.msalService.initialize().subscribe((x) => {
      this.msalService.instance.handleRedirectPromise();
    });
  }

  handleSignIn(event: Event) {
    
    this.msalService.loginPopup({
      scopes: ['User.Read'],
      prompt: 'login',
      extraQueryParameters: {
        max_age: '3600'
      }
    }).subscribe({
      next: result => {
        const account = result.account;

        setSessionItem('accessToken', result.idToken);
        setSessionItem('sessionToken', result.accessToken);
        setSessionItem('userAccount', account);

        this.router.navigate(['/cims']);
      },
      error: err => {
        console.error('Login failed', err);
      }
    });
  }

}
